import { render, staticRenderFns } from "./WsMenuItem.vue?vue&type=template&id=651ce380&"
import script from "./WsMenuItem.vue?vue&type=script&lang=js&"
export * from "./WsMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports